import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    redirect: "/",
    component: () =>
      import(
        /*webpackChunkName: "Layout" */ "@/components/layout/BaseLayout.vue"
      ),
    children: [
      {
        path: "/",
        name: "Home",
        component: () =>
          import(/*webpackChunkName: "Home" */ "@/views/Home.vue"),
        meta: {},
      },
      {
        path: "/detail/:type",
        name: "Detail",
        component: () =>
          import(/*webpackChunkName: "Home" */ "@/views/Detail.vue"),
        meta: {},
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
